export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 6C21.1377 6 22 6.86419 22 8V19C22 20.1358 21.1377 21 20 21H4C2.86227 21 2 20.1358 2 19V8C2 6.86419 2.86227 6 4 6H8C8 4.47473 9.47217 3 11 3H13C14.4923 3 15.9316 4.40703 15.9976 5.89383L16.0177 6H20ZM15.189 8C14.7083 8 14.2956 7.65801 14.2064 7.18569L14.0174 6.18569L14 6C14 5.57853 13.4225 5 13 5H11C10.5775 5 10 5.57853 10 6V7C10 7.55228 9.55228 8 9 8H4V19H20V8H15.189ZM12 11C10.8954 11 10 11.8954 10 13C10 14.1046 10.8954 15 12 15C13.1046 15 14 14.1046 14 13C14 11.8954 13.1046 11 12 11Z"
      fill="currentColor"
    />
    <path d="M8 8V6H16V8H8Z" fill="currentColor" />
    <path d="M4 14V12H20V14H4Z" fill="currentColor" />
  </svg>
);
